import root from './style.module.scss';
import { DialogProps, Box, Modal } from '@mui/material';

type CustomModalProps = {
  open: any;
  width?: string;
  close: () => void;
  children: React.ReactNode;
  type?: 'show' | 'add';
};

const CustomModal = ({ open, close, children, width = '50%', type = 'add' }: CustomModalProps) => {
  const handleClose: DialogProps['onClose'] = (event, reason) => {
    if (reason && reason === 'backdropClick') return;
    close();
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      return type === 'add' ? null : close();
    }
  };

  return (
    <Modal onKeyDown={handleKeyDown} open={Boolean(open)} onClose={() => false || handleClose}>
      <Box sx={{ maxWidth: width }} className={root.modal}>
        {children}
      </Box>
    </Modal>
  );
};

export default CustomModal;
